export default "/images/8e74ab782384bcf08aee3ec88d11601d.avif";